import React, {useEffect} from 'react';
import {getStatusBorderColor} from '../../../_legacy/Form/utils/status';
import {getStatuses} from './actions';
import styles from './styles.module.scss';

export const Status = (props: {status: string; entityId: string}) => {
    const {status, entityId} = props;
    const [statuses, setStatuses] = React.useState([]);

    useEffect(() => {
        if (entityId) {
            (async () => {
                const res = await getStatuses(entityId);
                setStatuses(res);
            })();
        }
    }, [entityId]);

    if (!entityId) return null;

    const statusData = statuses.find(item => item.Statdes === status) || {};
    const borderColor = getStatusBorderColor(statusData.Color);

    return (
        <div
            className={styles.component}
            style={{borderColor, backgroundColor: statusData.Color}}
        />
    );
};
